window.ScrollWatcher = function()
{
	this.init();
}

ScrollWatcher.prototype = {

	init:function()
	{
		var self = this;

		// bind events
		$window.on('scroll',self.scroll.bind(self));
		$window.on('resize',self.resize.bind(self));

		this.resize();
		this.scroll();

		// hack
		setTimeout(this.resize.bind(this), 500);
		setTimeout(this.resize.bind(this), 1000);
		setTimeout(this.resize.bind(this), 1500);
		setTimeout(this.resize.bind(this), 2000);
		setTimeout(this.resize.bind(this), 3000);
		setTimeout(this.resize.bind(this), 5000);
		setTimeout(this.resize.bind(this), 10000);
		setTimeout(this.resize.bind(this), 15000);
	},

	scroll:function()
	{
		var st = $window.scrollTop();

		if (st>50) {
			$body.addClass('is-scrolled');
		} else {
			$body.removeClass('is-scrolled');
		}
	},

	resize:function()
	{
		//
	}

};